<div mdbModal #confirmDeleteByNameModal="mdb-modal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="confirmDeleteByNameModalLabel" aria-hidden="true">
  <!-- destructive action: red header -->
  <div class="modal-dialog modal-notify modal-danger" role="document">
    <div class="modal-content" *ngIf="options">
      <div class="modal-header">
        <p id="confirmDeleteByNameModalLabel" class="heading lead">Confirm Delete {{ options.entityName }}</p>
        <button type="button" class="close" aria-label="Close" (click)="confirmDeleteByNameModal.hide()">
          <span aria-hidden="true" class="white-text">×</span>
        </button>
      </div>
      <!--modal-header-->
      <div class="modal-body">
        <div class="text-center mb-3">
          <mdb-icon fas icon="question-circle" size="4x" class="confirm-icon animated rotateIn"></mdb-icon>
        </div>
        <div class="mb-3">
          Are you sure you want to delete the {{ options.entityName }}
          <span class="delete-name">{{ options.name }}</span>?
        </div>
        <div class="mb-3">You will not be able to revoke this action.</div>
        <label for="confirmDeleteByNameInput" class="mb-2">
          To confirm, type the {{ options.nameLabel }} <strong class="keep-spaces">{{ options.name }}</strong> below:
        </label>
        <input id="confirmDeleteByNameInput" type="text" class="form-control"
          [class.is-valid]="isMatched" [(ngModel)]="confirmValue"
          autocomplete="off" spellcheck="false" (keyup.enter)="delete()">
        <small *ngIf="isMatched" class="d-block mt-1 text-success">✓ {{ options.matchLabel }} matches</small>
        <small *ngIf="!isMatched" class="d-block mt-1 text-muted">{{ options.matchLabel }} does not match</small>
        <div class="modal-footer justify-content-center mt-3 pb-0">
          <button type="button" mdbBtn color="danger" class="waves-light rounded text-white"
            [disabled]="!isMatched || isDeleting" (click)="delete()" mdbWavesEffect>Delete Permanently</button>
          <button type="button" mdbBtn color="secondary" class="rounded" outline="true"
            (click)="confirmDeleteByNameModal.hide()" mdbWavesEffect>No, thanks</button>
        </div>
      </div>
      <!--modal-body-->
    </div>
    <!--modal-content-->
  </div>
  <!--modal-dialog-->
</div>
<!--mdbModal-->
